import { render } from "./DisciplinesView.vue?vue&type=template&id=5f35f8ee"
import script from "./DisciplinesView.vue?vue&type=script&lang=js"
export * from "./DisciplinesView.vue?vue&type=script&lang=js"

import "./DisciplinesView.vue?vue&type=style&index=0&id=5f35f8ee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__